//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DedupeExportedDocumentFileNames: FeatureFlag = {"Id":"DedupeExportedDocumentFileNames","Label":"(KILL)[10.27]DedupeExportedDocumentFileNames","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. When active, SubmissionExporter.ExportIntoArchive renames a document to avoid a zip entry name collision (prefixing it 1_, 2_, etc.) when two exported documents would otherwise share the same file name. When killed, colliding documents are written to the archive under the same duplicate name.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
